import React, { useEffect, useState } from 'react';
import { material } from '../../../library/material';
import Navbar from '../../navbar/Navbar';
import { useTheme } from '@mui/material';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import { StyledTableCell } from '../../../shared/TableHeaderStyle';
import AddOrEditOtherProduct from './AddOrEditOtherProduct';
import { connect } from 'react-redux';
import Snackbar from '../../toastrmessage/Snackbar';
import { getOtherProduct, saveOrUpdateOtherProduct } from '../../../services/OtherStockService';


function OtherProduct(props) {

    const { userData, clinicData } = props;
    const userDetails = userData.authReducer.data;
    const clinicDetails = clinicData.clinicReducer.data;
    localStorage.setItem("menuName", "Other Product List");
    const theme = useTheme();
    const [isLoading, setIsLoading] = useState(false);
    const [otherProductList, setOtherProductList] = useState([]);
    const [openAddOrEditOtherProduct, setOpenAddOrEditOtherProduct] = useState({ action: false, data: null });
    const [openSnackBar, setOpenSnackBar] = useState({
        "action": false,
        "type": "",
        "message": "",
    });
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(0);
    const [totalElements, setTotalElements] = useState(0);

    useEffect(() => {
        getOtherProductList();
    }, []);

    const getOtherProductList = (paginationData) => {
        setIsLoading(true);
        const payload = {
            clinicId: clinicDetails.clinicId,
            orgId: userDetails.orgId,
            limit: paginationData ? paginationData.limit : 10,
            page: paginationData ? paginationData.page : 0,
            search: paginationData ? paginationData.search : ""
        }
        getOtherProduct(payload)
            .then((resp) => {
                setOtherProductList(resp.data.data.productData);
                setPage(Number(resp.data.data.currentPage));
                setRowsPerPage(resp.data.data.limit);
                setTotalElements(resp.data.data.totalRecords);
                setIsLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.data.info,
                    })
                } else {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.messages,
                    })
                }
            })
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        const payload = {
            limit: rowsPerPage,
            page: newPage,
        }
        getOtherProductList(payload)
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        const payload = {
            limit: event.target.value,
            page: page
        }
        getOtherProductList(payload)
    };

    const searchPatient = (value) => {
        const payload = {
            // limit: 100,
            // page: 0,
            search: value
        }
        getOtherProductList(payload)
    };

    const addProduct = () => {
        setOpenAddOrEditOtherProduct({ action: true, data: null })
    };

    const editProduct = (rowData) => {
        setOpenAddOrEditOtherProduct({ action: true, data: rowData })
    };

    const activeDeActive = (rowData) => {
        const payload = {
            orgId: userDetails.orgId,
            clinicId: clinicDetails.clinicId,
            id: rowData.id,
            product: rowData.product,
            supplier: rowData.supplier,
            productType: rowData.productType,
            active: rowData.active ? false : true
        }
        saveOrUpdateOtherProduct(payload)
            .then((resp) => {
                const payload = {
                    page: page,
                    limit: rowsPerPage
                }
                getOtherProductList(payload);
                setOpenSnackBar({
                    "action": true,
                    "type": "success",
                    "message": resp.data.data,
                })
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.data.info,
                    })
                } else {
                    setOpenSnackBar({
                        "action": true,
                        "type": "error",
                        "message": error.response.data.data,
                    })
                }
            })
    };

    return (
        <material.Grid spacing={2} className='container-fluid'
            sx={{
                [theme.breakpoints.down('sm')]: {
                    mt: 13
                },
                [theme.breakpoints.up('sm')]: {
                    mt: 12
                },
                [theme.breakpoints.up('md')]: {
                    mt: 12
                },
                [theme.breakpoints.up('lg')]: {
                    mt: 12
                },
            }}
        >
            <Navbar />
            <div className="row">
                <div className="col-12">
                    <span className="float-end">
                        <material.Button variant="contained" sx={{ textTransform: "none" }} onClick={addProduct} startIcon={<material.AddIcon />}>Add Product</material.Button>
                    </span>
                </div>
                <div className="col-12 mt-3">
                    <material.Paper sx={{ width: '100%', overflow: 'hidden', p: 3 }}>
                        <material.TableContainer sx={{ maxHeight: 600 }}>
                            <material.Table stickyHeader aria-label="sticky table">
                                <material.TableHead >
                                    <material.TableRow>
                                        <StyledTableCell>Supplier Name</StyledTableCell>
                                        <StyledTableCell>Product Name</StyledTableCell>
                                        <StyledTableCell>Product Type</StyledTableCell>
                                        <StyledTableCell>Action</StyledTableCell>
                                    </material.TableRow>
                                </material.TableHead>
                                {isLoading ? (
                                    <material.TableRow >
                                        <material.TableCell colSpan={10}>
                                            <SkeletonTheme baseColor="#bbdefb" highlightColor="#c6ff00" enableAnimation="true" inline="true" width="100% " height="30px">
                                                <Skeleton count={10} />
                                            </SkeletonTheme>
                                        </material.TableCell>
                                    </material.TableRow>
                                ) : (
                                    <>
                                        {otherProductList.length ? otherProductList.map((product, k) => (
                                            <material.TableRow
                                                key={k}
                                            >
                                                <material.TableCell size='small'>{product.supplier}</material.TableCell>
                                                <material.TableCell size='small'>{product.product}</material.TableCell>
                                                <material.TableCell size='small'>{product.productType}</material.TableCell>
                                                <material.TableCell>
                                                    <div className='d-flex flex-row'>
                                                        {product.active ? (<p style={{ color: "green", fontWeight: "bold" }}>active</p>) : (<p style={{ color: "red", fontWeight: "bold" }}>De-active</p>)}
                                                        <material.IconButton onClick={() => activeDeActive(product)} title={product.active ? "De-active" : "Active"}>
                                                            <material.Switch checked={product.active} color='secondary' />
                                                        </material.IconButton>
                                                        <material.IconButton onClick={() => editProduct(product)} title='Edit Product'>
                                                            <material.CreateIcon color='info' />
                                                        </material.IconButton>
                                                    </div>
                                                </material.TableCell>
                                            </material.TableRow>
                                        )) : (
                                            <material.TableRow >
                                                <material.TableCell colSpan={10}>
                                                    <h6 className='d-flex justify-content-center text-danger fw-bold'>No data found</h6>
                                                </material.TableCell>
                                            </material.TableRow>
                                        )}
                                    </>
                                )}
                            </material.Table>
                        </material.TableContainer>
                        <material.TablePagination
                            rowsPerPageOptions={[5, 10, 20]}
                            component="div"
                            count={totalElements}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </material.Paper>
                </div>
            </div>
            <AddOrEditOtherProduct
                openAddOrEditOtherProduct={openAddOrEditOtherProduct}
                setOpenAddOrEditOtherProduct={setOpenAddOrEditOtherProduct}
                userDetails={userDetails}
                clinicDetails={clinicDetails}
                getOtherProductList={getOtherProductList}
                page={page}
                rowsPerPage={rowsPerPage}
            />
            <Snackbar
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
            />
        </material.Grid>
    );
}

const mapStateToProps = (state) => {
    return {
        userData: state,
        clinicData: state
    };
};

export default connect(mapStateToProps)(OtherProduct);